module.exports = __webpack_public_path__ + "static/img/okamoto_03.a4d6102.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/okamoto_03.png
// module id = O77Z
// module chunks = 0